const type = 'SET_CARD_TEMPORARY_BLOCK_SUBMITTING';

const setCardTemporaryBlockSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCardTemporaryBlockSubmitting;
